<template>
  <div>
    <Index1 v-if="showWitch() == 0" />
    <Index2 v-else-if="showWitch() == 1" />
    <Index3 v-else />
  </div>
</template>

<script>
/* eslint-disable */
import Index1 from './Index1'
import Index2 from './index2'
import Index3 from './index3'
export default {
  components: {
    Index1,
    Index2,
    Index3
  },
  data() {
    return {
      
    }
  },
  inject: ['showWitch'],
  mounted() {
    console.log('showWitch', this.showWitch)
  },
  beforeDestroy() {
    
  },
  methods: {
    
  }
}
</script>

<style scoped lang="scss">

</style>